import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import axios from "axios";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Clock, User } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CoursesPage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${API}/courses`);
      setCourses(response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="flex items-center justify-center py-20">
          <div className="w-16 h-16 border-4 border-[#0f3e3e] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="courses-page">
      <Navbar />

      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#0f3e3e]" data-testid="courses-title">
              All Courses
            </h1>
            <p className="text-lg md:text-xl leading-relaxed text-muted-foreground mt-4">
              Browse our collection of expert-led courses
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course) => (
              <Card
                key={course.id}
                className="bg-white border border-border rounded-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:border-[#0f3e3e]/20 group"
                data-testid={`course-card-${course.id}`}
              >
                <CardHeader className="p-0">
                  <img
                    src={course.banner}
                    alt={course.title}
                    className="w-full h-48 object-cover"
                    data-testid={`course-banner-${course.id}`}
                  />
                </CardHeader>
                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold text-[#0f3e3e] mb-2" data-testid={`course-title-${course.id}`}>
                    {course.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                    {course.description}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <User className="w-4 h-4" />
                      <span>{course.instructor}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <BookOpen className="w-4 h-4" />
                      <span>{course.chapter_count} chapters</span>
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="p-6 pt-0 flex items-center justify-between">
                  <div>
                    <p className="text-2xl font-bold text-[#0f3e3e]" data-testid={`course-price-${course.id}`}>
                      ₹{course.price}
                    </p>
                  </div>
                  <Link to={`/courses/${course.id}`}>
                    <Button
                      className="bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90 font-medium"
                      data-testid={`view-course-button-${course.id}`}
                    >
                      View Course
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            ))}
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default CoursesPage;
